module.exports = __webpack_public_path__ + "static/fonts/Roboto-Light.72ed9537.woff";